import request from '@/utils/request'

export function getCardGroupCountStat(data) {
  return request({
    url: 'api/v1/card-stat/getCardGroupCount',
    method: 'post',
    data: data
  })
}

export function getCardGroupSumStat(data) {
  return request({
    url: 'api/v1/card-stat/getCardGroupUserCount',
    method: 'post',
    data: data
  })
}

export function getCardInfoStat(data) {
  return request({
    url: 'api/v1/card-stat/getCardInfoCount',
    method: 'post',
    data: data
  })
}
